import { SavedFeedbackMetadata } from 'generated/graphql';
import { createContext } from 'react';

interface SaveFeedbackContextValue {
  feedbackID: string;
  labelID: string;
  summaryIndex: number;
  snippetID: string;
  savedFeedbackMetadata?: SavedFeedbackMetadata[];
}

export const SaveFeedbackContext =
  createContext<SaveFeedbackContextValue | null>(null);
